import React, { ReactNode, MouseEvent } from 'react'

interface IconButtonProps {
  'onClick'?: (e: MouseEvent<HTMLButtonElement>) => void
  'children': ReactNode
  'className'?: string
  'color'?: 'inherit' | 'primary' | 'secondary'
  'aria-label'?: string
}

export const IconButton: React.FC<IconButtonProps> = ({ onClick, children, className = '', color, ...props }) => {
  const colorClass = color ? `icon-button--${color}` : ''

  return (
    <button
      type="button"
      className={`icon-button ${colorClass} ${className}`}
      onClick={onClick}
      aria-label={props['aria-label']}
    >
      {children}
    </button>
  )
}
